import React from 'react';
import styles from './text-link.module.scss';
import { Link } from '@reach/router';

interface Props {
  href: string;
}

export const TextLink: React.FC<Props> = ({ children, href }) => {
  const isExternal = href.includes('http');

  if (isExternal) {
    return (
      <a href={href} target="_blank" rel="noopener noreferrer" className={styles.link}>
        {children}
      </a>
    );
  }

  return (
    <Link to={href} className={styles.link}>
      {children}
    </Link>
  );
};
